import { render, staticRenderFns } from "./StatsPlayerRow.vue?vue&type=template&id=2e20b76b&scoped=true&"
import script from "./StatsPlayerRow.vue?vue&type=script&lang=js&"
export * from "./StatsPlayerRow.vue?vue&type=script&lang=js&"
import style0 from "./StatsPlayerRow.vue?vue&type=style&index=0&id=2e20b76b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20b76b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
